import { EmployeesEdit } from '@Resources/employees/EmployeesEdit';
import { EmployeesList } from '@Resources/employees/EmployeesList';
import { EmployeesShow } from '@Resources/employees/EmployeesShow';
import { ResourceDefinition } from '@Utils/types';

export const employeesResource: ResourceDefinition = {
  options: { label: 'menu.employees' },
  list: EmployeesList,
  show: EmployeesShow,
  edit: EmployeesEdit,
};
